export default __webpack_public_path__ + "static/4da5f094c814970e3a2878f68eb33c40.svg";